import { render, staticRenderFns } from "./booking-details-tab.vue?vue&type=template&id=bddb5d80&scoped=true&"
import script from "./booking-details-tab.vue?vue&type=script&lang=js&"
export * from "./booking-details-tab.vue?vue&type=script&lang=js&"
import style0 from "./booking-details-tab.vue?vue&type=style&index=0&id=bddb5d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb5d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem})
